module.exports = __webpack_public_path__ + "index/img/correct.e7b2f5d1.png";